import { useEffect, useState } from 'react';
import AdminToggle from './AdminToggle';
import AdminImagePicker from './AdminImagePicker';
import { useBusinessSettings } from '../../context/BusinessSettingsContext';

export default function AdminMenuItemCard({
  item,
  categoryOptions,
  onUpdateCategory,
  onToggleField,
  onUpdateImageUrl,
  onUpdateImageFile,
  onDelete,
}) {
  const { formatPrice } = useBusinessSettings();
  const httpFromItem =
    item.image && String(item.image).startsWith('http') ? item.image : '';
  const [urlDraft, setUrlDraft] = useState(httpFromItem);

  useEffect(() => {
    const next =
      item.image && String(item.image).startsWith('http') ? item.image : '';
    setUrlDraft(next);
  }, [item.id, item.image]);

  const previewUrl = item.image || null;

  const persistUrl = () => {
    const trimmed = urlDraft.trim();
    const currentHttp =
      item.image && String(item.image).startsWith('http') ? item.image : '';
    if (trimmed !== currentHttp) {
      onUpdateImageUrl(item.id, trimmed);
    }
  };

  return (
    <div
      style={{
        background: 'white',
        borderRadius: 'var(--radius)',
        marginBottom: '1rem',
        boxShadow: 'var(--shadow-sm)',
        border: '1px solid var(--border)',
        overflow: 'hidden',
      }}
      className="admin-menu-item-card"
    >
      <div
        style={{
          padding: '1rem 1rem .85rem',
          borderBottom: '1px solid var(--border)',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: '1rem',
            marginBottom: '1rem',
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div
              style={{
                fontWeight: 600,
                fontSize: '.95rem',
                color: 'var(--dark)',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                flexWrap: 'wrap',
              }}
            >
              {item.name}
              {item.soldOut && (
                <span
                  style={{
                    background: '#fee',
                    color: 'var(--red-dark)',
                    fontSize: 'var(--text-label-medium-size)',
                    fontWeight: 700,
                    padding: '2px 8px',
                    borderRadius: 999,
                    textTransform: 'uppercase',
                  }}
                >
                  Sold Out
                </span>
              )}
              {item.featured && (
                <span
                  style={{
                    background: '#fff8e6',
                    color: 'var(--gold)',
                    fontSize: 'var(--text-label-medium-size)',
                    fontWeight: 700,
                    padding: '2px 8px',
                    borderRadius: 999,
                    textTransform: 'uppercase',
                  }}
                >
                  Featured
                </span>
              )}
            </div>
            <div style={{ fontSize: '.78rem', color: 'var(--gray)', marginTop: 4 }}>
              {item.category} · {item.prepMinutes} min prep
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.65rem', flexShrink: 0 }}>
            <span
              style={{
                fontWeight: 800,
                color: 'var(--teal-dark)',
                fontSize: '.95rem',
                whiteSpace: 'nowrap',
              }}
            >
              {formatPrice(item.price)}
            </span>
            <button
              type="button"
              title="Delete dish"
              onClick={() => onDelete(item.id)}
              style={{
                width: 40,
                height: 40,
                background: 'rgba(226, 75, 75, 0.1)',
                border: '1px solid rgba(226, 75, 75, 0.35)',
                color: 'var(--red)',
                borderRadius: 10,
                fontSize: '1rem',
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'background .15s',
              }}
            >
              ✕
            </button>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            gap: '1.25rem',
            alignItems: 'flex-end',
          }}
        >
          <AdminToggle
            on={item.active}
            onChange={() => onToggleField(item.id, 'active')}
            label={item.active ? 'On' : 'Off'}
          />
          <AdminToggle
            on={item.soldOut}
            onChange={() => onToggleField(item.id, 'soldOut')}
            colorOn="#e24b4a"
            label="Stock"
          />
          <AdminToggle
            on={item.featured}
            onChange={() => onToggleField(item.id, 'featured')}
            colorOn="var(--gold)"
            label="Spot"
          />
        </div>
        <div style={{ marginTop: '.95rem', maxWidth: 340 }}>
          <label
            htmlFor={`cat-${item.id}`}
            style={{
              display: 'block',
              fontSize: '.7rem',
              fontWeight: 700,
              letterSpacing: '.06em',
              textTransform: 'uppercase',
              color: 'var(--gray)',
              marginBottom: 6,
            }}
          >
            Category
          </label>
          <input
            id={`cat-${item.id}`}
            className="form-input"
            list={`cat-options-${item.id}`}
            value={item.category || ''}
            onChange={(e) => onUpdateCategory(item.id, e.target.value)}
            placeholder="e.g. Noodles, Curries"
            style={{ fontSize: '.84rem' }}
          />
          <datalist id={`cat-options-${item.id}`}>
            {categoryOptions.map((cat) => (
              <option key={`${item.id}-${cat}`} value={cat} />
            ))}
          </datalist>
        </div>
      </div>

      <div style={{ padding: '1rem 1rem 1.15rem' }}>
        <AdminImagePicker
          previewUrl={previewUrl}
          fallbackEmoji={item.emoji || '🍽'}
          urlValue={urlDraft}
          onUrlChange={setUrlDraft}
          onUrlBlur={persistUrl}
          onFileSelect={(file) => {
            if (file) onUpdateImageFile(item.id, file);
          }}
          onClearImage={() => onUpdateImageUrl(item.id, '')}
        />
      </div>

    </div>
  );
}
